import tw, { css, theme } from "twin.macro"

export const modalScreenStyles = {
    css: css({ ".ant-modal-body": theme`typo.mregular` }),
    width: "min(1280px, 90vw)",
    styles: {
        content: {
            height: "min(956px, 95vh)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
        },
        body: { flex: 1, overflow: "hidden" }
    }
}

export const modalFullScreenStyles = {
    css: css({ ".ant-modal-body": theme`typo.mregular` }),
    width: "calc(100vw - 64px)",
    styles: {
        content: {
            height: "calc(100vh - 112px)",
            overflow: "hidden",
            display: "flex",
            flexDirection: "column"
        },
        body: { flex: 1, overflow: "hidden" }
    }
}

export const cssBaseAntTable = (p) => css`
    &.ant-table-wrapper .ant-table {
        scrollbar-color: ${theme`colors.scrollbar_color`} ${theme`colors.scrollbar_track_color`};
    }

    .ant-table .ant-table-content,
    .ant-table .ant-table-body {
        ${tw`scrollbar-thin scrollbar-webkit`}
    }

    .ant-table .ant-table-body {
        overflow: ${p.scroll?.y ? "auto !important" : "unset"};
    }

    .ant-table-tbody-virtual {
        --scrollbar-track-width: 7px;

        .ant-table-tbody-virtual-scrollbar .ant-table-tbody-virtual-scrollbar-thumb {
            background: ${theme`colors.scrollbar_color`} !important;
        }

        .ant-table-tbody-virtual-scrollbar-vertical {
            width: var(--scrollbar-track-width) !important;
            .ant-table-tbody-virtual-scrollbar-thumb {
                right: 2px;
            }
        }

        .ant-table-tbody-virtual-scrollbar-horizontal {
            height: var(--scrollbar-track-width) !important;
        }
    }
`

export const cssContainerButtonGroup = css`
    .ant-dropdown-menu {
        padding: 0;

        .ant-dropdown-menu-item {
            padding: 8px 16px;
            color: ${theme`colors.text_body`};
            transition: unset;
            ${theme`typo.mregular`}
        }

        .ant-dropdown-menu-item.ant-dropdown-menu-item-disabled {
            color: ${theme`colors.text_disable`};
        }

        .ant-dropdown-menu-item.ant-dropdown-menu-item-active {
            color: ${theme`colors.primary`};
        }

        .ant-dropdown-menu-item-divider {
            margin: 0;
        }
    }
`

export const cssBaseAntPagination = css`
    &.ant-table-pagination {
        margin-bottom: 0;
    }

    .ant-pagination-item {
        border-radius: 2px;
        border-color: ${theme`colors.gray300`};
        font-size: 14px;
        font-weight: 400;
    }

    .ant-pagination-item,
    .ant-pagination-next,
    .ant-pagination-prev {
        min-width: 23px;
        height: 23px;
        line-height: 21px;
        position: relative;
    }

    .ant-pagination-item-active {
        background-color: ${theme`colors.primary`};
        border-color: ${theme`colors.primary`};
    }

    .ant-pagination-item-active a {
        color: ${theme`colors.white`};
    }
`
